<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="商品の選び方" />
    <choices />
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Choices from '@/components/modules/choice/Choices'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    Choices,
    Breadcrumb,
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '商品の選び方',
            path: 'https://b-call.jp/choice',
          },
        ],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Choice.vue